/* ============================================================
   zh-magazine-infinite.js
   Infinite Scroll für den Magazin-Feed (sections/zh-magazine-home.liquid).

   Progressive Enhancement: der "Mehr Artikel laden"-Link bleibt im
   HTML stehen (crawlbar für Suchmaschinen, funktionierender Fallback
   ohne JS). Läuft dieses Script, wird der Link versteckt und die
   nächste Seite automatisch nachgeladen, sobald der Nutzer in die Nähe
   des Feed-Endes scrollt.

   Warum die komplette Seite geholt wird und nicht die Section
   Rendering API (?section_id=): die API liefert auf diesem Store
   durchgehend null bzw. 404, auf allen Templates. DOMParser lädt aus
   dem geparsten Dokument weder Bilder noch Scripts, es kostet also nur
   die HTML-Bytes, keine Requests und keine Fremd-JS-Ausführung.

   Nach data-max-auto automatischen Ladevorgängen erscheint der Button
   wieder. Das hält den Footer per Tastatur erreichbar (WCAG 2.2) und
   begrenzt das Datenvolumen auf Mobilgeräten.

   Vanilla JS, keine Dependencies.
   ============================================================ */
(function () {
  'use strict';

  /* Vorlaufstrecke: früh genug laden damit kein Leerlauf entsteht,
     spät genug damit ein kurzer Blick auf die Seite nichts nachlädt. */
  var ROOT_MARGIN = '400px 0px';
  /* Muss zum card_order-Schritt in sections/zh-magazine-home.liquid passen:
     mobil liegen Feed und Rail per display:contents flach in einem
     Flex-Container, die inline order entscheidet über die Reihenfolge. */
  var ORDER_STEP = 10;
  var DEFAULT_MAX_AUTO = 3;
  var READY_ATTR = 'data-zh-mag-ready';

  /* Die Section hardcodet ihre deutschen Strings (siehe Schema-Defaults)
     statt Locale-Keys, weil ein neuer Key in alle 28 locales/*.json
     müsste. Hier genauso. */
  var MSG_ERROR = 'Weitere Artikel konnten nicht geladen werden. Bitte den Button benutzen.';

  function cardKey(card) {
    var link = card.querySelector('a[href]');
    if (!link) return '';
    return (link.getAttribute('href') || '').split('#')[0];
  }

  function loadedMessage(count) {
    if (count === 1) return '1 weiterer Artikel geladen.';
    return count + ' weitere Artikel geladen.';
  }

  function initFeed(root) {
    var stream = root.querySelector('[data-zh-mag-stream]');
    var more = root.querySelector('[data-zh-mag-more]');
    if (!stream || !more) return;

    var link = more.querySelector('[data-zh-mag-more-link]');
    var status = more.querySelector('[data-zh-mag-status]');

    var nextUrl = more.getAttribute('data-next-url') || '';
    if (!nextUrl) return;

    var maxAuto = parseInt(more.getAttribute('data-max-auto'), 10);
    if (isNaN(maxAuto) || maxAuto < 0) maxAuto = DEFAULT_MAX_AUTO;

    /* Doppelinitialisierung verhindern: das Script-Tag steckt im
       paginate-Block, und init() läuft bei shopify:section:load erneut
       über alle Feeds. Ohne Marke bekäme derselbe Feed zwei Observer und
       zwei Click-Listener. */
    if (root.getAttribute(READY_ATTR) === 'true') return;
    root.setAttribute(READY_ATTR, 'true');

    /* Bereits sichtbare Artikel merken. Wird zwischen zwei Requests ein
       Artikel veröffentlicht, verschiebt sich die Pagination und Seite 2
       liefert einen Artikel von Seite 1 erneut. */
    var seen = Object.create(null);
    var nextOrder = 0;

    var existing = stream.querySelectorAll('.zh-mag-item');
    for (var i = 0; i < existing.length; i++) {
      var key = cardKey(existing[i]);
      if (key) seen[key] = true;
      var order = parseInt(existing[i].style.order, 10);
      if (!isNaN(order) && order > nextOrder) nextOrder = order;
    }
    var featured = root.querySelector('.zh-mag-feat');
    if (featured) {
      var featuredKey = cardKey(featured);
      if (featuredKey) seen[featuredKey] = true;
    }

    var loading = false;
    var autoLoads = 0;
    var failed = false;
    var observer = null;
    /* Kam der laufende Ladevorgang vom Nutzer, muss der Fokus danach
       gezielt weitergereicht werden. Beim Observer-Trigger dagegen nie,
       das wäre ein Fokusdiebstahl mitten im Lesen. */
    var userInitiated = false;

    function announce(message) {
      if (status) status.textContent = message;
    }

    /* Der Link verschwindet nur, wenn Auto-Nachladen die Kontrolle hat. */
    function autoInCharge() {
      return !failed && autoLoads < maxAuto;
    }

    function setLoading(on) {
      loading = on;
      more.classList.toggle('is-loading', on);
      more.setAttribute('aria-busy', on ? 'true' : 'false');
      if (!link) return;
      if (on) {
        /* Während des Ladens NICHT verstecken. Hat der Nutzer den Link
           gerade per Tastatur ausgelöst, fiele er mit hidden aus dem
           Accessibility-Tree und der Fokus landete auf <body>
           (WCAG 2.4.3). Stattdessen für die Dauer deaktivieren. Im
           Auto-Modus ist er ohnehin schon versteckt. */
        link.setAttribute('aria-disabled', 'true');
        return;
      }
      link.removeAttribute('aria-disabled');
      link.hidden = autoInCharge();
    }

    /* Fokus auf den Titel-Link des ersten neuen Artikels: der Nutzer
       landet im nachgeladenen Inhalt statt auf <body>, und der
       Screenreader liest den Artikeltitel vor. */
    function focusCard(card) {
      var target = card.querySelector('.zh-mag-item__title a') || card.querySelector('a[href]');
      if (target) target.focus();
    }

    function showButton() {
      more.classList.remove('is-loading');
      more.removeAttribute('aria-busy');
      if (link) link.hidden = false;
    }

    function stopObserving() {
      if (observer) observer.disconnect();
      observer = null;
    }

    /* Nach dem Anhängen kann das Button-Row weiterhin im Viewport
       liegen. IntersectionObserver feuert dann ohne Scroll nicht erneut,
       der Feed würde stehen bleiben. Neu observieren erzwingt einen
       frischen Callback mit dem aktuellen Zustand. */
    function rearm() {
      if (!observer) return;
      observer.unobserve(more);
      observer.observe(more);
    }

    /* Liefert { added, first }: first ist die erste angehängte Karte im
       Dokument, als Fokusziel nach einem manuellen Klick. */
    function appendFrom(doc) {
      var incomingStream = doc.querySelector('[data-zh-mag-stream]');
      var added = 0;
      var first = null;

      if (incomingStream) {
        var incoming = incomingStream.querySelectorAll('.zh-mag-item');
        var frag = document.createDocumentFragment();
        for (var i = 0; i < incoming.length; i++) {
          var card = incoming[i];
          var key = cardKey(card);
          if (key && seen[key]) continue;
          if (key) seen[key] = true;
          nextOrder += ORDER_STEP;
          var copy = document.importNode(card, true);
          copy.style.order = String(nextOrder);
          frag.appendChild(copy);
          if (!first) first = copy;
          added++;
        }
        if (added > 0) stream.appendChild(frag);
      }

      var incomingMore = doc.querySelector('[data-zh-mag-more]');
      nextUrl = incomingMore ? incomingMore.getAttribute('data-next-url') || '' : '';
      if (link && nextUrl) link.setAttribute('href', nextUrl);

      if (added > 0) announce(loadedMessage(added));
      return { added: added, first: first };
    }

    function load() {
      if (loading || failed || !nextUrl) return;
      setLoading(true);

      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var batch = appendFrom(new DOMParser().parseFromString(html, 'text/html'));

          /* Vor setLoading(false), denn das versteckt den Link ggf. wieder.
             Der Fokus muss weg sein, bevor das passiert. */
          if (userInitiated && batch.first) {
            userInitiated = false;
            focusCard(batch.first);
          }
          setLoading(false);

          if (!nextUrl) {
            stopObserving();
            /* Brachte die letzte Runde nichts Neues, steht der Fokus noch
               auf dem Link, den more.hidden gleich mitnimmt. Dann ans Ende
               des Feeds setzen statt auf <body> fallen lassen. */
            if (userInitiated) {
              userInitiated = false;
              var lastCards = stream.querySelectorAll('.zh-mag-item');
              if (lastCards.length) focusCard(lastCards[lastCards.length - 1]);
            }
            more.hidden = true;
            return;
          }
          if (autoLoads >= maxAuto) {
            stopObserving();
            showButton();
            return;
          }
          /* Lieferte die Seite nur Duplikate, würde ein rearm() dieselbe
             leere Runde wiederholen. Direkt die nächste Seite versuchen. */
          if (batch.added === 0) {
            autoLoads++;
            load();
            return;
          }
          rearm();
        })
        .catch(function (error) {
          if (window.console && window.console.warn) {
            window.console.warn('[zh-magazine-infinite]', error);
          }
          /* Ab hier übernimmt der Link wieder als normaler Seitenwechsel.
             Er war während des Ladens sichtbar, ein etwaiger Tastaturfokus
             bleibt also erhalten. */
          failed = true;
          userInitiated = false;
          setLoading(false);
          stopObserving();
          showButton();
          announce(MSG_ERROR);
        });
    }

    if (link) {
      link.addEventListener('click', function (event) {
        /* Nach einem Fehler nicht abfangen: der Browser soll normal
           auf die nächste Seite navigieren. */
        if (failed) return;
        event.preventDefault();
        /* aria-disabled sperrt nur die Maus (pointer-events), Enter käme
           weiterhin durch. */
        if (loading) return;
        userInitiated = true;
        autoLoads = 0;
        load();
        /* Nach einem manuellen Klick darf Auto-Nachladen wieder greifen,
           sofern es überhaupt aktiviert ist. */
        if (!observer && maxAuto > 0) startObserving();
      });
    }

    function startObserving() {
      observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          if (loading || failed || !nextUrl) return;
          if (autoLoads >= maxAuto) {
            stopObserving();
            showButton();
            return;
          }
          autoLoads++;
          load();
        }
      }, { rootMargin: ROOT_MARGIN });
      observer.observe(more);
    }

    if (maxAuto > 0) {
      if (link) link.hidden = true;
      startObserving();
    }
  }

  function init() {
    /* Fehlt eine der APIs, bleibt der Link als normaler Seitenwechsel
       stehen. Kein Polyfill, kein Fallback-Timer. */
    if (!window.IntersectionObserver || !window.fetch || !window.DOMParser) return;
    var feeds = document.querySelectorAll('[data-zh-mag-feed]');
    for (var i = 0; i < feeds.length; i++) initFeed(feeds[i]);
  }

  // Internal pure helpers exposed for unit tests only.
  window.__zhMagazineInfinite = {
    cardKey: cardKey,
    loadedMessage: loadedMessage
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Im Theme-Editor ersetzt Shopify das Section-HTML. Das dabei neu
     eingefügte <script> führt nicht aus, der Observer zeigte danach auf
     einen abgehängten Knoten und der Feed bliebe bis zum Reload stehen.
     Konvention im Theme, siehe zh-motion.js und theme.js. Bereits
     initialisierte Feeds schützt READY_ATTR. */
  document.addEventListener('shopify:section:load', init);
})();
